import chalk from 'chalk';

export function listTemplates() {
  console.log(chalk.blue('\n📋 Available FeedInbox component types:\n'));
  
  console.log(chalk.green('react-vanilla'));
  console.log('  React components with vanilla CSS');
  console.log('  • Clean, customizable styling');
  console.log('  • No external CSS framework required');
  console.log('  • Perfect for custom design systems\n');
  
  console.log(chalk.green('react-tailwind'));
  console.log('  React components with Tailwind CSS');
  console.log('  • Utility-first CSS approach');
  console.log('  • Requires Tailwind CSS in your project');
  console.log('  • Highly customizable with utilities\n');
  
  console.log(chalk.green('react-shadcn'));
  console.log('  React components with shadcn/ui');
  console.log('  • Modern component library');
  console.log('  • Requires shadcn/ui setup');
  console.log('  • Beautiful, accessible components\n');
  
  console.log(chalk.yellow('Usage:'));
  console.log('  npx @feedinbox/cli add react-vanilla');
  console.log('  npx @feedinbox/cli add react-tailwind');
  console.log('  npx @feedinbox/cli add react-shadcn\n');
}